import React, {Component} from 'react';
import {Modal, Spin} from "antd";
import SunburstZoomableChart from './SunburstZoomableChart';

export default class Chart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
      location: [],
      showModal: false,
    }
  }

  toggleShowModal = () => {
    this.setState({
      showModal: !this.state.showModal,
    });
  };

  componentWillReceiveProps(nextProps) {
    if(nextProps && nextProps.data && JSON.stringify(nextProps.data) !== JSON.stringify(this.props.data)) {
      const location = [];
      // Object.entries(nextProps.data).forEach(([key, value]) => {
      //   location.push({name: key, value: value.length});
      // });
      this.setState({
        data: nextProps.data,
        location
      })
    }
  }


  render() {
    return (
      <Spin spinning={this.props.loading}>
        <div className="gx-card">
          <i className="icon icon-map-popup-info" onClick={this.toggleShowModal}
             style={{float: 'right', marginRight: '5px', marginTop: '5px', cursor: 'pointer'}}/>
          {/*<Button size='small' icon="expand" onClick={this.toggleShowModal} style={{float: 'right'}}/>*/}
          <div className="gx-card-body">
            <h4 className="dash-card-title gx-mb-3">Asset Distribution</h4>
            <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
              {
                this.state.data && !this.state.showModal &&
                <SunburstZoomableChart data={this.state.data} size={this.props.width / 5} width={this.props.width / 5}/>
              }
              {this.state.data && this.state.showModal &&
              <Modal
                title={`Distribution of ${(this.state.data && this.state.data.count) || ''} Asssets`}
                visible={this.state.showModal}
                onOk={this.toggleShowModal}
                onCancel={this.toggleShowModal}
                width={this.props.width - (this.props.width / 5)}
              >
                <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                  <SunburstZoomableChart data={this.state.data} size={this.props.width / 3}
                                         width={this.props.width / 3}/>
                </div>
              </Modal>
              }
            </div>
          </div>
        </div>
      </Spin>
    );

  }
}
// (<Node id="GAU" value={100} label="GuwahatiX"/>)
// https://visjs.github.io/vis-network/docs/network/nodes.html
// https://github.com/lifeomic/react-vis-network/blob/master/README.md
